export class MarketViewsConstants {
	public static readonly MARKET_MOVES_ASSET_CLASS_DCR_KEYS = ['MARKET_VIEWS_EQUITIES', 'MARKET_VIEWS_FIXED_INCOME', 'MARKET_VIEWS_OTHER'];

	public static readonly MARKET_MOVES_HEADER_DCR_KEYS = ['VIEW', 'REGION', 'COMMENTARY'];

	public static readonly MARKET_MOVES_ASSET_CLASS_ITEM_NUMBER = [5, 7, 1];
}
